var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"ml-1",staticStyle:{"position":"relative"},attrs:{"height":"calc(100vh - 110px)"}},[_c('div',{ref:"viewer",staticStyle:{"position":"absolute","left":"0","right":"0","top":"0","bottom":"0"},attrs:{"data-bind":"dxReportViewer: $data"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }